import { Option } from 'shared/components/Select/models/Option';
import { electronicTradingLabel } from 'shared/constants/filters/advanced/electronicTradingLabel';
import { EElectronicTrading } from 'shared/types/filters/advanced/electronicTrading';

export const electronicTradingOptions = [
  new Option(EElectronicTrading.WithoutTrading, electronicTradingLabel[EElectronicTrading.WithoutTrading]),
  new Option(EElectronicTrading.WithTrading, electronicTradingLabel[EElectronicTrading.WithTrading]),
];
